import { useFormikContext } from 'formik';
import React from 'react';
import { ENDPOINTS } from 'site-constants';

import { AutocompleteSelect } from '@candu-ai/analytics/ui';
import { SelectInputWrapper } from 'dashboard/pages/Segment/components/DefinitionFormFields/DefinitionFormComponents';

import { AutocompleteFromHammockGetAll } from './AutocompleteFromHammockGetAll';
import { Filter, FilterTypes } from './types';

export const OperationOperandAutocompleteField = ({ type, onChange, ...props }: any) => {
  const { values, setFieldValue } = useFormikContext<Filter>();

  if (type === FilterTypes.SegmentId) {
    return (
      <AutocompleteFromHammockGetAll
        isSegment
        allowCustomValues
        endpoint={ENDPOINTS.segmentsDefinition}
        InputWrapper={SelectInputWrapper}
        onChange={(e: any) => onChange(e.value)}
        setFieldValue={setFieldValue}
        values={values}
        {...props}
      />
    );
  }

  if (type === FilterTypes.ContentId) {
    return (
      <AutocompleteFromHammockGetAll
        allowCustomValues
        endpoint={ENDPOINTS.contentMetadata}
        InputWrapper={SelectInputWrapper}
        onChange={(e: any) => onChange(e.value)}
        setFieldValue={setFieldValue}
        values={values}
        {...props}
      />
    );
  }

  return (
    <AutocompleteSelect
      allowCustomValues
      InputWrapper={SelectInputWrapper}
      onChange={(e) => onChange(e.value)}
      setFieldValue={setFieldValue}
      values={values}
      disableQueryOnEmptySearch={type === FilterTypes.UserId}
      {...props}
    />
  );
};
